import React from 'react';
import styled from 'styled-components';
// import 'antd/dist/antd.less';
import 'antd/dist/antd.variable.min.css';
import './index.css';
import './custom.css';
import useDetectDimension from 'rev.sdk.js/Hooks/useDetectDimension';
import * as CustomApp from '../Utils/CustomApp';
import * as CtxUtil from '../Utils/CtxUtil';
import styledCss from './styledCss';
import customStyledCss from './customStyledCss';
import peopleStyledCss from './peopleStyledCss';
import useArea from '../Hooks/useArea';
import {ConfigProvider} from 'antd';

function Provider(props) {
  useDetectDimension();
  const {isPeople} = useArea();

  React.useEffect(() => {
    CtxUtil.onCtxRendered();
  }, []);

  return (
    <>
      {CustomApp.renderGlobalHtmlHelmet()}
      <Wrapper id="rev-AppContext" isPeople={isPeople}>
        {props.children}
        {CustomApp.renderGlobalModals()}
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  ${styledCss}

  ${customStyledCss}
  ${(props) => (props.isPeople ? peopleStyledCss : '')}
`;

export {Provider};
